export const getSafeWhiteboardBounds = (objects, padding = 20) => {
    const bounds = (objects || [])
        .filter((object) => object?.visible !== false)
        .map((object) => {
            try {
                return object.getBoundingRect?.(true, true);
            } catch (error) {
                return null;
            }
        })
        .filter((rect) => rect
            && [rect.left, rect.top, rect.width, rect.height].every(Number.isFinite)
            && rect.width >= 0
            && rect.height >= 0);

    if (!bounds.length) return null;

    const minX = Math.min(...bounds.map((rect) => rect.left));
    const minY = Math.min(...bounds.map((rect) => rect.top));
    const maxX = Math.max(...bounds.map((rect) => rect.left + rect.width));
    const maxY = Math.max(...bounds.map((rect) => rect.top + rect.height));

    const width = maxX - minX;
    const height = maxY - minY;

    if (![minX, minY, width, height].every(Number.isFinite)) return null;

    return {
        left: minX - padding,
        top: minY - padding,
        width: Math.max(width + padding * 2, 1),
        height: Math.max(height + padding * 2, 1),
    };
};
